import { SplitLayout } from '@components/layout';
import { AuthenticationHeader } from '@components/layout/authentication/AuthenticationHeader';
import { useAuth } from '@hooks/useAuth';
import { pathToVP } from '@utils/route';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { SignUpForm } from 'src/routes/public/Authentication/SignUp/SignUpForm';

const SignupView = () => {
    const { isLoggedIn, isUserLoading } = useAuth();
    const [searchParams] = useSearchParams();
    const next = searchParams.get('next');

    if (isUserLoading) {
        return (
            <FormattedMessage
                id="common.loading"
                defaultMessage="Loading..."
                description="Loading message for usage while loading data in a page"
            />
        );
    }

    if (isLoggedIn) {
        window.location.replace(pathToVP(next ?? '/').toString());
    }

    return (
        <>
            <title>Victron Professional - Sign Up</title>
            <SplitLayout>
                <AuthenticationHeader />
                <SignUpForm />
            </SplitLayout>
        </>
    );
};

export { SignupView };
